/** Variación con signo: "+15 %", "−2,5 %". */
export function formatPct(pct: number | null): string {
  if (pct === null || !Number.isFinite(pct)) return '—';
  const abs = Math.abs(pct).toLocaleString('es-AR', { maximumFractionDigits: 1 });
  const sign = pct > 0 ? '+' : pct < 0 ? '−' : '';
  return `${sign}${abs} %`;
}

export function pctOf(oldCents: number, newCents: number): number | null {
  if (oldCents <= 0) return null;
  return ((newCents - oldCents) / oldCents) * 100;
}

const dateTime = new Intl.DateTimeFormat('es-AR', {
  day: '2-digit',
  month: '2-digit',
  year: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDateTime(iso: string): string {
  return dateTime.format(new Date(iso));
}

export function shortBatch(batchId: string): string {
  return `#${batchId.slice(-6)}`;
}
